import { DSPalette } from "@clickbank-ui/seller-design-system";
import { DSBreakpoints } from "@clickbank-ui/seller-design-system";
import { Language } from "@mui/icons-material";
import { Box, MenuItem, Select } from "@mui/material";
import { useEffect } from "react";
import { Trans } from "react-i18next";

import i18n from "../../i18n";

const breakpoints = DSBreakpoints.default;
const { palette } = DSPalette;

const styles = {
	languageSelect: {
		display: "flex",

		"#languagePicker": {
			marginTop: 0.5,
			fontSize: "1rem"
		},

		"#languagePickerLabel": {
			display: "none"
		},

		[breakpoints.down("xs")]: {
			paddingTop: ".5rem"
		},

		"& .MuiInputBase-input": {
			padding: "0 38px 0 8px !important",

			"&.MuiSelect-select:hover": {
				backgroundColor: "Transparent"
			}
		},
		"& .MuiInputBase-root": {
			height: "auto"
		}
	},
	menu: {
		// disablePortal messes up some styling
		"&.MuiList-root": {
			padding: 0
		}
	},
	startAdornment: {
		marginRight: "4px",
		height: "18px",
		width: "18px",
		color: palette.primary.main,
		pointerEvents: "none",
		zIndex: 5
	}
};

const languages = {
	en: "English",
	de: "Deutsch",
	es: "Español",
	fr: "Français",
	it: "Italiano",
	pt: "Português"
};

export default () => {
	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const locale = urlParams.get("lang");
		if (locale) {
			// always remove lang param
			// this avoids conflicts if the user tries to manually change the language
			const url = new URL(window.location.href);
			const lang = url.searchParams.get("lang").substring(0, 2);
			if (lang) {
				url.searchParams.delete("lang");
				window.history.pushState({ path: url.href }, "", url.href);
				i18n.changeLanguage(lang.toLowerCase());
			}
			urlParams.delete("lang");
		}
	}, []);
	const handleChange = async event => {
		if (languages[event.target.value]) {
			await i18n.changeLanguage(event.target.value);
			window.location.reload();
			window.scrollTo(0, 0); // window was scrolling to bottom :/
		}
	};

	return (
		<Box sx={styles.languageSelect}>
			<label id="languagePickerLabel" htmlFor="languagePicker">
				<Trans i18nKey="NavBar.languagePicker.label">Choose language</Trans>
			</label>
			<Select
				disableUnderline
				variant="standard"
				MenuProps={{
					disablePortal: true, // for a11y
					MenuListProps: { sx: styles.menu }
				}}
				defaultValue={i18n.language}
				id="languagePicker"
				labelId="languagePickerLabel"
				onChange={handleChange}
				startAdornment={<Language sx={styles.startAdornment} />}
			>
				{Object.keys(languages).map(lang => (
					<MenuItem key={lang} value={lang}>
						{languages[lang]}
					</MenuItem>
				))}
			</Select>
		</Box>
	);
};
